import {PowerShellScriptLocation} from '../enumerations/power-shell-script-location';
import {PowerShellInputType} from '../enumerations/power-shell-input-type';
import {PowerShellReturnType} from '../enumerations/power-shell-return-type';
import {Definition, SimpleDefinition} from '../definition';
import {Activity, ActivityType} from '../activity';
import {LogOnType} from '../enumerations/log-on-type';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class RunPowerShellScriptActivity extends Activity {
  public ActivityExecutionCondition: string;
  public ScriptLocation: PowerShellScriptLocation;
  public Script: string;
  public FailOnMissing: boolean;
  public InputType: PowerShellInputType;
  public ParametersTable: Definition[];
  public Arguments: SimpleDefinition[];
  public ReturnType: PowerShellReturnType;
  public ReturnValueLookup: string;
  public Advanced: boolean;
  public PowerShellUser: string;
  public PowerShellUserPassword: string;
  public ImpersonatePowerShellUser: boolean;
  public ImpersonatePowerShellUserLogOnType: LogOnType;
  public ImpersonatePowerShellUserLoadUserProfile: boolean;

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.RunPowerShellScript);
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['ScriptLocation'] = ActivityPropertyDataType.POWER_SHELL_SCRIPT_LOCATION;
    this._properties['Script'] = ActivityPropertyDataType.HTMLSTRING;
    this._properties['FailOnMissing'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['InputType'] = ActivityPropertyDataType.POWER_SHELL_INPUT_TYPE;
    this._properties['ParametersTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this._properties['Arguments'] = ActivityPropertyDataType.STRING_ARRAY;
    this._properties['ReturnType'] = ActivityPropertyDataType.POWER_SHELL_RETURN_TYPE;
    this._properties['ReturnValueLookup'] = ActivityPropertyDataType.STRING;
    this._properties['Advanced'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['PowerShellUser'] = ActivityPropertyDataType.STRING;
    this._properties['PowerShellUserPassword'] = ActivityPropertyDataType.STRING;
    this._properties['ImpersonatePowerShellUser'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['ImpersonatePowerShellUserLogOnType'] = ActivityPropertyDataType.LOG_ON_TYPE;
    this._properties['ImpersonatePowerShellUserLoadUserProfile'] = ActivityPropertyDataType.BOOLEAN;
    this._advancedProperties = [
      'ActivityExecutionCondition',
      'PowerShellUser',
      'PowerShellUserPassword',
      'ImpersonatePowerShellUser',
      'ImpersonatePowerShellUserLogOnType',
      'ImpersonatePowerShellUserLoadUserProfile',
    ];
    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();

    if (this.ImpersonatePowerShellUser === false) {
      this.ImpersonatePowerShellUserLogOnType = LogOnType.None;
      this.ImpersonatePowerShellUserLoadUserProfile = null;
    }

    if (this.ImpersonatePowerShellUserLogOnType == null) {
      this.ImpersonatePowerShellUserLogOnType = LogOnType.None;
    }

    if (this.InputType !== PowerShellInputType.Arguments) {
      this.Arguments = null;
    }

    if (this.InputType !== PowerShellInputType.Parameters) {
      this.ParametersTable = null;
    }

    if (this.ReturnType !== PowerShellReturnType.Explicit) {
      this.ReturnValueLookup = null;
    }
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('run-power-shell-script', this.dialogConfig);
  }
}
